export enum OrderStatus {
  PendingPayment = 'PENDING_PAYMENT',
  Paid = 'PAID',
  PendingAccept = 'PENDING_ACCEPT',
  Producing = 'PRODUCING',
  PendingPickup = 'PENDING_PICKUP',
  Delivering = 'DELIVERING',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Refunding = 'REFUNDING',
  Refunded = 'REFUNDED',
}

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  [OrderStatus.PendingPayment]: '待付款',
  [OrderStatus.Paid]: '已支付',
  [OrderStatus.PendingAccept]: '待接单',
  [OrderStatus.Producing]: '制作中',
  [OrderStatus.PendingPickup]: '待取餐',
  [OrderStatus.Delivering]: '配送中',
  [OrderStatus.Completed]: '已完成',
  [OrderStatus.Cancelled]: '已取消',
  [OrderStatus.Refunding]: '退款中',
  [OrderStatus.Refunded]: '已退款',
}

export const getOrderStatusLabel = (status: OrderStatus): string =>
  ORDER_STATUS_LABELS[status]

export const ORDER_STATUS_TRANSITIONS: Record<OrderStatus, readonly OrderStatus[]> = {
  [OrderStatus.PendingPayment]: [OrderStatus.PendingPayment],
  [OrderStatus.Paid]: [OrderStatus.Paid],
  [OrderStatus.PendingAccept]: [OrderStatus.PendingAccept, OrderStatus.Producing, OrderStatus.Cancelled],
  [OrderStatus.Producing]: [OrderStatus.Producing, OrderStatus.PendingPickup, OrderStatus.Delivering],
  [OrderStatus.PendingPickup]: [OrderStatus.PendingPickup, OrderStatus.Completed],
  [OrderStatus.Delivering]: [OrderStatus.Delivering, OrderStatus.Completed, OrderStatus.Cancelled],
  [OrderStatus.Completed]: [OrderStatus.Completed],
  [OrderStatus.Cancelled]: [OrderStatus.Cancelled],
  [OrderStatus.Refunding]: [OrderStatus.Refunding],
  [OrderStatus.Refunded]: [OrderStatus.Refunded],
}

export const getAllowedOrderStatusTransitions = (status: OrderStatus): OrderStatus[] =>
  [...(ORDER_STATUS_TRANSITIONS[status] ?? [status])]
